import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import store from "./store";
import { AuthProvider } from "context/AuthProvider";
import { RouteProvider } from "context/RouteProvider";
import { ProfileImageProvider } from "context/ProfileImageProvider";
import { DispachCountProvider } from "context/OrderCountProvider";
import { AllDriverStatusCountProvider } from "context/DriverAllOrderStatusCountProvider";
import { NotificationProvider } from "context/NotificationProvider";
import { UserCountProvider } from "context/UserCountProvider";
import { BulkCountProvider } from "context/BulkCountProvider";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <AuthProvider>
          <DispachCountProvider>
            <AllDriverStatusCountProvider>
              <ProfileImageProvider>
                <NotificationProvider>
                  <UserCountProvider>
                     <BulkCountProvider>
                  <RouteProvider>
                    <App />
                  </RouteProvider>
                  </BulkCountProvider>
                  </UserCountProvider>
                </NotificationProvider>
              </ProfileImageProvider>
            </AllDriverStatusCountProvider>
          </DispachCountProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

serviceWorker.unregister();
